import React from "react"
import moment from "moment"
import { Hidden } from "@material-ui/core"

export default ({ value }) => {
  try {
    const momentValue = value && moment(value)
    const year = moment().year()

    return (
      <span title={momentValue && moment(momentValue).local().format()}>
        <Hidden xsDown>
          {momentValue && momentValue.format(year !== momentValue.year() ? "Do MMMM YYYY" : "dddd Do MMMM")}
        </Hidden>
        <Hidden smUp>
          {momentValue && momentValue.format(`ddd Do MMM${year !== momentValue.year() ? " YYYY" : ""}`)}
        </Hidden>
      </span>
    )
  } catch (ex) {
    return <span>Data invalid.</span>
  }
}
